import React from 'react';
import { Grid, TextField, Button, Typography, Divider, Box, Paper } from '@mui/material';
import SignatureCanvas from 'react-signature-canvas';
import { Dialog, DialogTitle, DialogContent, DialogActions } from '@mui/material';

const SignaturesSection = ({ 
  formData, 
  handleInputChange,
  signatureDialogOpen, 
  signaturePadRef, 
  handleSignatureOpen, 
  handleSignatureClear, 
  handleSignatureSave, 
  handleSignatureClose 
}) => {
  return (
    <Box>
      <Typography variant="h6" sx={{ color: '#008080', mb: 2, fontWeight: 600 }}>
        Verification & Signatures
      </Typography>
      <Divider sx={{ mb: 3 }} />
      
      <Grid container spacing={3} alignItems="flex-end">
        <Grid item xs={12} sm={6}>
          <Box sx={{ mb: 2 }}>
            <Typography variant="subtitle2" gutterBottom>Anaesthesiologist Signature</Typography>
            {formData.anaesthesiologist_signature_blob ? (
              <Paper variant="outlined" sx={{ p: 1, backgroundColor: '#f9f9f9', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                <img 
                  src={`data:image/png;base64,${formData.anaesthesiologist_signature_blob}`} 
                  alt="Signature" 
                  style={{ maxHeight: '100px', maxWidth: '100%' }} 
                />
                <Button size="small" onClick={() => handleSignatureOpen('anaesthesiologist_signature_blob')} sx={{ mt: 1 }}>
                  Resign
                </Button>
              </Paper>
            ) : (
              <Button 
                variant="outlined" 
                fullWidth 
                onClick={() => handleSignatureOpen('anaesthesiologist_signature_blob')}
                sx={{ py: 3, borderStyle: 'dashed' }}
              >
                Capture Signature
              </Button>
            )}
          </Box>
        </Grid>

        <Grid item xs={12} sm={6}>
          <TextField
            fullWidth
            label="Anaesthesiologist Name"
            name="anaesthesiologist_name"
            value={formData.anaesthesiologist_name || ''}
            onChange={handleInputChange}
          />
        </Grid>

        <Grid item xs={12}>
          <TextField
            fullWidth
            label="Post-Op Nurse Name & ID"
            name="post_op_nurse_name_id"
            value={formData.post_op_nurse_name_id || ''}
            onChange={handleInputChange}
            placeholder="Name - ID"
          />
        </Grid>
      </Grid>

      {/* Signature Dialog */}
      <Dialog open={signatureDialogOpen} onClose={handleSignatureClose} maxWidth="sm" fullWidth>
        <DialogTitle>Capture Signature</DialogTitle>
        <DialogContent>
          <Box sx={{ border: '1px solid #ccc', borderRadius: '4px', mt: 1 }}>
            <SignatureCanvas
              ref={signaturePadRef}
              penColor="black"
              canvasProps={{ width: 550, height: 200, className: 'sigCanvas' }}
            />
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleSignatureClear} color="secondary">Clear</Button>
          <Button onClick={handleSignatureClose}>Cancel</Button>
          <Button onClick={handleSignatureSave} variant="contained" color="primary">Save Signature</Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default SignaturesSection;
